import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Container, Form, Card, Row, Col, FloatingLabel } from "react-bootstrap";
import MasterToolBar from "./MasterToolBar";
import Table from "./Table";
import { changeMaterial, loadAllMaterial, loadMaterial, loadMaterialLookup, resetMaterial, saveMaterialService } from "../action/materialAction";
import { notification } from "../action/notificationAction";

// import { loadAllUser,  getUserPassword } from "../action/userAction";

export default function Materail({ permitted }) {


  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const [selectedMaterialId, setSelectedMaterialId] = useState();


  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [status, setStatus] = useState('active');

  const lookup = useSelector(
    (state) => state.lookup.category
  );


  const materials = useSelector(
    (state) => state.material.materials
  );


  const material = useSelector(
    (state) => state.material.material
  );


  // const materials = [{
  //   category: "AAAA",
  //   name: "AAA",
  //   spec: "123"
  // }]



  const handleShow = (seleted) => {
    setErrors({});
    if (seleted && seleted.original.id) {

      setShow(true);
      setSelectedMaterialId(seleted.original.id);
      dispatch(loadMaterial(seleted.original.id));
    }
    else {
      setSelectedMaterialId(null);
      setShow(true);
    }

  }

  const handleClose = () => {
    setErrors({});
    setSelectedMaterialId(null);
    dispatch(resetMaterial());
    dispatch(loadAllMaterial(status));
    setShow(false);
  }


  React.useEffect(() => {
    dispatch(loadAllMaterial(status));
  }, [dispatch, status]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'id',
        accessor: 'id'
      },

      {
        Header: 'Category',
        accessor: 'categoryname',

      },
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Spec',
        accessor: 'spec',
      }, {
        Header: 'Closed',
        accessor: 'closedDate',
        show: status === 'active'
      }
    ],
    [status]
  )


  const handleSubmit = e => {

    e.preventDefault();
    // get our new errors
    const newErrors = findFormErrors()
    // Conditional logic:
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {

      let dataToPost = {};
      let method= "POST";

      if (!material.id) {
        dataToPost={
          ...material,
          categoryid: material.categoryid !== "0" ? Number(material.categoryid) : null,
          status: "Y"
        };
      }
      else {
        dataToPost={
          ...material,
          categoryid: material.categoryid !== "0" ? Number(material.categoryid) : null,
        };
        method="PATCH"
      }
      
      saveMaterialService(dataToPost,method).then(res=>{
        dispatch(notification(res));
        handleClose();
        dispatch(resetMaterial());
        dispatch(loadMaterialLookup());
      })
      .catch(err=>{
        dispatch(notification(err));
      })
    }

  }
  const findFormErrors = () => {

    const { name, categoryid } = material
    const newErrors = {}

    if (!name || name === '') newErrors.name = 'Name cannot be blank!'
    if (!categoryid || categoryid === "0") newErrors.category = 'Select a material category!'

    return newErrors
  }



  const setField = (field, value, model) => {
    dispatch(changeMaterial({ name: field, value, model }));
    // Check and see if errors exist, and remove them from the error object:
    if (!!errors[field]) setErrors({
      ...errors,
      [field]: null
    })
  }

  // eslint-disable-next-line no-unused-vars
  const [createPermission, setCreatePermission] = React.useState(permitted(`MATERIAL_CREATE`));
  // eslint-disable-next-line no-unused-vars
  const [updatePermission, setUpdatePermission] = React.useState(permitted(`MATERIAL_UPDATE`));

  const theme = useSelector((state) => state.ThemeOptions);


  return (
    <React.Fragment>
      <MasterToolBar createPermission updatePermission id={material.id} show={show} handleShow={handleShow} handleSubmit={handleSubmit} handleClose={handleClose}></MasterToolBar>
      {
        !show ? (

          <Container fluid >
            <Table columns={columns} data={materials} title="Materials" edit={handleShow} hideColumn={status === 'active' ? ['closedDate'] : []}> </Table>
          </Container>) : (
          <Container fluid >

            <Card>
              <Card.Header className={`${theme.headerBackgroundColor}`}> Material Detial </Card.Header>
              <Card.Body className="p-0">
                <Form>
                  <Row className="m-auto">
                    <Card className="p-0 col-md-6 col-sm-12 col-xl-4">

                      <Card.Body>
                        <Row className="mb-3">
                          <Col>
                            <FloatingLabel controlId="floatingCategory" label="Category">
                              <Form.Select id="floatingCategory" aria-label="category" isInvalid={!!errors.category} value={material.categoryid ?? "0"} onChange={e => setField('categoryid', e.target.value)}>
                                <option value="0">Select Category</option>
                                {
                                  lookup && lookup.MATERIAL ? (
                                    lookup.MATERIAL.map((e, i) => {
                                      return <option key={`cat_${i}`} value={e.id} >{e.name}</option>
                                    })
                                  ) : null
                                }

                              </Form.Select>
                              <Form.Control.Feedback type='invalid'>{errors.category} </Form.Control.Feedback>
                            </FloatingLabel>
                          </Col>
                        </Row>
                        <Row className="mb-3">

                          <Col>
                            <FloatingLabel controlId="floatingName" label="Name">
                              <Form.Control type="text" placeholder=" Name" isInvalid={!!errors.name} value={material.name ?? ""} onChange={e => setField('name', e.target.value)} />
                              <Form.Control.Feedback type='invalid'>{errors.name} </Form.Control.Feedback>
                            </FloatingLabel>
                          </Col>
                        </Row>

                        <Row className="mb-3">

                          <Col>
                            <FloatingLabel controlId="floatingSpec" label="Spec">
                              <Form.Control type="text" placeholder="Spec" isInvalid={!!errors.spec} value={material.spec ?? ""} onChange={e => setField('spec', e.target.value)} />
                              <Form.Control.Feedback type='invalid'>{errors.spec} </Form.Control.Feedback>
                            </FloatingLabel>
                          </Col>
                        </Row>



                      </Card.Body>
                    </Card>

                  </Row>
                  {/* <div className="d-grid flex-fill d-md-flex gap-2  justify-content-md-end  ">

                
              </div> */}
                </Form>
              </Card.Body>
            </Card>


          </Container>)
      } </React.Fragment>);








}